module.exports = __webpack_public_path__ + "img/help_statistics_small.bb1c2253.png";